<template>
    <div class="clearfix rounded pb-5 mx-auto">



        <div class="d-none">
            <div class="col-sm-6 pl-0">
                <div class="custom-search">
                    <b-input-group class="mb-0">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end mb-3">
            <div style="max-width: 200px;">
                <b-form-select @change="getLeaves" v-model="leave_year">
                    <b-form-select-option v-for="(year, n) in years" :key="n" :value="year">{{year}}</b-form-select-option>
                </b-form-select>
            </div>
        </div>

        <div class="row justify-content-center no-margin">
            <div class="col-sm-12  px-0">
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <div class=""> <!-- Mustafijur: 19-05-2026: employee-table-wrapper table-sticky-height-->

                        <!-- Abdullah responsive added table responsive  -->
                        <table class="employee-list-table table-responsive employee-list-table-leave dataTable table-overflow table-sticky ess-custom-table">
                            <thead>
                                <tr class="table-head ">
                                    <td  v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" style="cursor:pointer;">
                                       <template v-if="column.name !='to' && column.name !='from'">
                                            <label class="custom-label"><span>{{column.label}}</span></label>
                                       </template>
                                    <template v-else>
                                        <label class="custom-label"><span> {{column.label}}</span>
                                        <div class="table-header">
                                            <div class="table sub-header">(YYYY-MM-DD)</div>
                                        </div>
                                       </label>
                                    </template>
                                    </td>

                                     <!-- Abdullah 19-05-26 added this -->
                                <td class="text-center" v-if="ce"><label class="custom-label">Action</label> </td>
                            </tr>
                        </thead>

                        <tbody>

                            <template v-if="paginatedData.length > 0">
                                <tr class="table-row hover-bg" v-for="(leave , n) in paginatedData" :key="n">

                                    <td class="">
                                        <img v-if="leave.leave_type == 'Sick Leave'" v-bind:src="$api_url+'/images/menu/hospital.svg'" class="mr-3"/>
                                        <img v-else-if="leave.leave_type == 'Casual Leave'" v-bind:src="$api_url+'/images/menu/plane.png'" class="mr-3"/>
                                        <img v-else v-bind:src="$api_url+'/images/menu/clock.png'" class="mr-3"/>
                                        {{leave.leave_type}}
                                    </td>
                                    <td class="">
                                        {{leave.from}}
                                    </td>
                                    <td class="">
                                        {{ leave.to }}
                                    </td>
                                    <td class="">
                                        <!-- {{leave.number_of_days}}
                                        <span v-if="leave.number_of_days > 1">days</span>
                                        <span v-else>day</span> -->

                                        <template v-if="leave.leave_day == 0">
                                            {{leave.number_of_days}}
                                            <span v-if="leave.number_of_days > 1">days</span>
                                            <span v-else>day</span>
                                        </template>
                                        <template v-else-if="leave.leave_day == 1">First Half</template>
                                        <template v-else-if="leave.leave_day == 2">Second Half</template>
                                    </td>
                                    <td class="leave-reason-wrapper">
                                        <diV>
                                            {{leave.reason}} <br />
                                            <b-link v-if="leave.attachment != null" @click="downloadFileContent('/images/employee/'+ leave.company_id + '/leaves/' + leave.attachment)"><img :src="$api_url+'/images/download_image.png'"  class="" /> </b-link>
                                        </diV>
                                    </td>

                                    <td class="text-center status-wrapper" :class="leave.status.toLowerCase()">

                                        <span class="leave-status" v-if="leave.status == 'Approved'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                                        <span class="leave-status" v-if="leave.status == 'Applied'"><i class="fa fa-circle mr-1"></i>Pending</span>
                                        <span class="leave-status" v-if="leave.status == 'Declined'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                                    </td>

                                    <td class="text-left">
                                        {{leave.updated_by}}
                                    </td>

                                    <!-- Abdullah responsive added text-right  -->
                                    <td class="position-relative text-right" v-if="ce">
                                        <template  v-if="leave.status == 'Applied'">
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                            <div class="dropdown-menu action-dropdown-menu w-200" aria-labelledby="actionDropdown">
                                                <b-button-toolbar class="">
                                                    <b-button-group class="mr-0">
                                                        <!-- <b-button class="mr-3 rounded edit-btn" title="Edit Work Location" @click="editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button> -->

                                                            <b-button class="rounded delete-btn" title="Delete" @click="deleteLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)">
                                                                <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                            </b-button>


                                                    </b-button-group>
                                                </b-button-toolbar>
                                            </div>
                                        </template>

                                    </td>
                                </tr>
                            </template>
                            <!-- Mustafijur: 19-05-2026 commented  -->
                            <!-- <template v-else>
                                <tr class="hover-bg table-row">
                                    <td class="cursor-pointer trz_relative text-center" colspan="7">No Result Found!</td>
                                </tr>
                            </template> -->
                        </tbody>
                    </table>
                    <!-- Mustafijur: 19-05-2026 Added: Starts  -->
                    <div v-if="paginatedData.length == 0" class="list-no-data">
                        No records found.
                    </div>
                    <!-- Mustafijur: 19-05-2026 Added: Starts  -->
                    </div>

                    <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                        <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">

                        </div>
                    </div>
                    <div class="mt-2" v-if="paginatedData.length > 0">
                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                                <li class="page-item disabled m-2">View</li>
                                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                            </ul>
                            <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                        <!-- <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ><template #prev-text><span>Previous</span></template><template #next-text><span>Next</span></template></b-pagination-nav>
                        -->
                        </div>
                </b-overlay>
            </div>
        </div>
        <!--- search employee and add leave --->
        <b-modal id="bv-modal-add-leave" size="xl" scrollable  hide-footer title="Leave Details">
            <search-employee v-if="this.employee_id == 0"  v-on:childToParent="setEmployee"></search-employee>
            <employee-leave-details v-if="this.employee_id > 0"  :editflg="0" v-on:childToParent="getLeaves"></employee-leave-details>
        </b-modal>
        <!-- update leave data -->
        <b-modal id="bv-modal-edit-leave" size="xl" scrollable  hide-footer title="Leave Details">
            <!-- leave_type_id , flg_status , from , to -->

            <employee-leave-details v-if="this.employee_id > 0"  :editflg="1" :leave_type_id="this.tmp_leave_type_id" :flg_status="this.tmp_flg_status" :from="this.tmp_from" :to="this.tmp_to" v-on:childToParent="getLeaves"></employee-leave-details>
        </b-modal>


        <b-modal id="bv-modal-import-leave" scrollable  hide-footer title="Import Leaves">
            <b-overlay :show="showoverlay" rounded="sm" class="">
                <b-form-file id="datafile" name="datafile" @change="uploadLeaveFile"  accept=".xlsx,.xls"></b-form-file>
                <!--<b-button type="button" v-if="has_file" @click="checkFileData" variant="primary" size="lg">Validate file data</b-button>
                <b-button type="button" v-if="has_file" @click="processFileData" variant="primary" size="lg">Process file data</b-button>-->


                <div v-if='errormsg'>
                    <div v-if="errormsg.length > 0" class="alert alert-danger my-3">Total error {{errormsg.length}}</div>
                    <ul class="list-group ">
                        <li class="list-group-item list-group-item-danger" v-for='error in errormsg'>{{error}}</li>
                    </ul>
                </div>
            </b-overlay>
        </b-modal>
    </div>
</template>
<script>
    import moment from 'moment'
    export default{

        mounted() {
            if(this.check_ce == 1)
            {
                if(this.ce_flg == 1)
                    this.ce = true;
                else
                    this.ce = false;

            }

            if(this.manager)this.ce=false;
        },
        props: [ 'flg' , 'manager'],
        components: {},
        data(){
            /** Sohel Code Starts Here */
            let sortOrders = {};
            let columns = [
                            {label: 'Leave Type', name: 'leave_type'},
                            {label: 'From', name: 'from'},
                            {label: 'To', name: 'to'},
                            {label: 'No of Days', name: 'number_of_days'},
                            {label: 'Reason', name: 'reason'},
                            {label: 'Status', name: 'status'},
                            {label: 'Updated By', name: 'updated_by'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});
            /** Sohel Code Ends Here */

            return {
                /** Sohel Code Starts Here */
                columns: columns,
                sortKey: 'employee_name',
                sortOrders: sortOrders,
                /** Sohel Code Ends Here */

                leaves:[],

                showoverlay:false,
                showoverlay_list:false,
                movenext : false,

                errormsg:[],
                fdata: {  },

                leave_year: new Date().getFullYear(),
                years: [],

                search:'',
                length: 20,
                pagination: {currentPage: 1, pages:1},
                temp_length: 20,
                length_options: [],

                ce : true,
                employee_id : 0,

                approved_leaves_today : 0,
                pending_leaves_today : 0,
                pending_leaves_fiscal_year : 0,


                tmp_leave_type_id : 0,
                tmp_flg_status : 0,
                tmp_from : '',
                tmp_to : '',


                start_date: null,
                end_date: null,
                lv : [],
                this_month_holidays : [],
                this_month : 1,
                this_year : 2020,
                weekly_holidays : [6],
                first_day_of_week : 7,
                total_working_day : 0,
                total_weekends : 0,
                total_holidays : 0,

                masks :
                    {
                        title: 'MMMM YYYY',
                        weekdays: 'WW',
                        navMonths: 'MMM',
                        input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                        dayPopover: 'WWW, MMM D, YYYY',
                        data: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
                    },

                attributes: [
                        {
                            key: 'today',
                            dot: 'pink',
                            dates: new Date(),
                        }
                    ],
                people:0,
            }
        },
        methods:{
            monthDetails: function(x)
            {
                let currentObj = this;
                let year = x['year'];
                let month = x['month'];
                let st_date = new Date(year , month - 1 , 1);
                let en_date = new Date(year , month , 0);

                this.this_month = x['month'];
                this.this_year = x['year'];

                this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
                this.end_date = moment(String(en_date)).format('Do MMMM YYYY');

                // fetch holidays dynamically from controller
                axios.get(this.$api_url+'/front/holidays/details' , {
                    params: {
                        st_date: this.start_date,
                        en_date: this.end_date,
                    }
                }).then(function(response){

                    this.weekly_holidays = response.data.report.week_holidays.split(',').map(function(item){ return parseInt(item, 10) + 1;});
                    this.first_day_of_week = parseInt(response.data.report.week_start_day) + 1;

                    this.this_month_holidays = response.data.holidays;

                    this.total_working_day = response.data.report.total_working_day;
                    this.total_weekends = response.data.report.weekends;
                    this.total_holidays = response.data.report.holidays;

                }.bind(this)).catch(function (error){ currentObj.serverError(error);});;

            },
            importLeaves: function()
            {
                this.$bvModal.show('bv-modal-import-leave');
            },
            uploadLeaveFile:function(event)
            {
                if(!this.checkNet()) return false;
                this.showoverlay = true;
                this.errormsg = [];
                // this function upload the logo
                this.empfile = event.target.files[0];

                const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }
                const data = new FormData();
                data.append('empfile', this.empfile);

                axios.post(this.$api_url+'/front/employee/leave/import/import', data , config).
                    then(function (response){



                        this.$bvToast.toast('Processing the data feed file.', {
                                            title: `Job on progress`,
                                            variant: 'info',
                                            solid: true
                                        });

                        this.$bvModal.hide('bv-modal-import-leave');

                        this.getLeaves();

                    }.bind(this)).
                    catch(function (error)
                            {
                                //alert(error.response.data.errors);
                            });
            },
            getLeaveYears(){
                axios.get(this.$api_url + '/front/leave-years/list').then(response => {
                    this.years = response.data;
                });
            },
            getLeaves: function()
            {
                if(!this.checkNet()) return false;

                if(this.flg == 0)
                    this.employee_id = 0;


                this.$bvModal.hide('bv-modal-leave-details');
                let currentObj = this;
                axios.get(this.$api_url+'/front/employees/leaves/fiscalyear?flg=' + this.flg , {
                    params: {
                        //employee_id: this.employeeId
                        year: this.leave_year
                    }
                }).then(function(response){
                    this.leaves = response.data.leaves;
                    this.employee_id = response.data.employee_id;

                    this.$bvModal.hide('bv-modal-edit-leave');
                    this.$bvModal.hide('bv-modal-add-leave');
                    console.log(this.leaves);


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },

            getApprovePendingLeavesToday: function()
            {
                if(!this.checkNet()) return false;

                let currentObj = this;
                axios.get(this.$api_url+'/front/approve-pending/leaves/today' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.approved_leaves_today = response.data.approved_leaves_today;
                    this.pending_leaves_today = response.data.pending_leaves_today;
                    this.pending_leaves_fiscal_year = response.data.pending_leaves_fiscal_year;


                }.bind(this)).catch(function (error){ currentObj.serverError(error);});
            },
            setEmployee: function(x)
            {
                this.employee_id = x;
            },
            addNew()
            {
                if(this.flg == 0)
                    this.employee_id = 0;

                this.$bvModal.show('bv-modal-add-leave');
            },

            //editLeave(leave.employee_id,leave.leave_type_id,leave.flg_status,leave.from,leave.to)
            // editLeave: function(employee_id , leave_type_id , flg_status , from , to)
            // {
            //     if(!this.checkNet()) return false;
            //     let currentObj = this;

            //     /*let formData = new FormData();
            //     formData.append('employee_id', employee_id);
            //     formData.append('leave_type_id', leave_type_id);
            //     formData.append('flg_status', flg_status);
            //     formData.append('from', from);

            //     axios.post(this.$api_url+'/front/employee/leaves/range', formData)
            //         .then(function(response){
            //             //data
            //         this.$validator.reset();
            //     }.bind(this))
            //     .catch(function (error)
            //     {
            //         currentObj.serverError(error);
            //     });*/

            //     this.employee_id = 0;
            //     let formData = new FormData();
            //     formData.append('employee_id' , employee_id);
            //     axios.post(this.$api_url+'/front/employee/setemployee', formData)
            //         .then(function (response)
            //         {
            //             this.employee_id = employee_id;

            //             this.tmp_leave_type_id = leave_type_id;
            //             this.tmp_flg_status = flg_status;
            //             this.tmp_from = from;
            //             this.tmp_to = to;

            //             this.$bvModal.show('bv-modal-edit-leave');

            //         }.bind(this))
            //         .catch(function (error)
            //         {
            //             currentObj.showoverlay = false;
            //             currentObj.serverError(error);
            //         });


            // },
            deleteLeave: function(employee_id , leave_type_id , flg_status , from , to)
            {
                let formData = new FormData();
                formData.append('employee_id' , employee_id);
                formData.append('leave_type_id' , leave_type_id);
                formData.append('from' , from);
                formData.append('to' , to);
                formData.append('flg_status' , flg_status);



                axios.post(this.$api_url+'/front/leave/delete/range', formData)
                    .then(function (response)
                    {
                        this.$bvToast.toast('Deleted!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });


                        this.getLeaves();
                        this.getApprovePendingLeavesToday();

                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },


            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;


                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {

                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/front/signatory/save', formData, config)
                        .then(function (response)
                        {
                            //console.log(response.data);
                            this.leaves = response.data;

                            this.$bvToast.toast('Saved!', {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                            this.showoverlay_list = false;
                            this.showoverlay = false;
                            this.resetForm();
                            //this.movenext = true;

                            this.$bvModal.hide('bv-modal-signatory');

                        }.bind(this))
                        .catch(function (error)
                        {
                            this.showoverlay_list = false;
                            this.showoverlay = false;

                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },

        },
        created: function(){

            this.getLeaveYears();
            this.getLeaves();
            this.getApprovePendingLeavesToday();
            Fire.$on('reloadUsers', () => {this.getLeaves()});
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.leaves;
                this.people = this.leaves.length;
                this.length_options = [{ value: 10, text: "10" },{ value: 20, text: "20" },
                                                    { value: 50, text: "50" },
                                                    { value: 100, text: "100" },
                                                    { value: 200, text: "200" },
                                                    { value: 500, text: "500" },
                                                    { value: this.leaves.length, text: "All" }];
                if (this.search)
                {

                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if(this.columns[index] != undefined)
                            {
                                if (this.columns[index].type && this.columns[index].type === 'date')
                                {
                                    return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                                }
                                else if (this.columns[index].type && this.columns[index].type === 'number')
                                {
                                    return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                                }
                                else
                                {
                                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                                }
                            }

                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
